import type { ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

type ButtonAreaProps = {
	children: ReactNode;
	direction?: 'column' | 'row';
	className?: string;
};

const ButtonArea = ({
	children,
	direction = 'column',
	className,
}: ButtonAreaProps) => {
	return (
		<div
			className={twMerge(
				'flex px-5 pb-5',
				direction === 'column' ? 'flex-col gap-4' : 'flex-row gap-2 *:flex-1',
				className,
			)}
		>
			{children}
		</div>
	);
};

export default ButtonArea;
